<template>
  <v-flex class="widgets" lg6>
    <v-card>
      <v-card-title>
        <div class="headline">{{ widgetTitle }}</div>
        <div class="grey--text">Click on the different coloured segments to view the corresponding data in your quote report.</div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="graphData.headers"
          :items="graphData.rows">
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.quote_count }}</td>
            <td>{{ props.item.conversion_count }}</td>
            <td>{{ props.item.conversion_rate }}</td>
            <td>{{ props.item.quote_value }}</td>
            <td>{{ props.item.sales_value }}</td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <dialog-filter-config fc-key="quote_val_per_rep" :widget-title="widgetTitle"></dialog-filter-config>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import BaseWidget from '../base-widget';
import DialogFilterConfig from '../dialog-filter';
import Vue from "vue";

export default {
  name: "online-sales-report",
  extends: BaseWidget,
  data() {
    return {
      widgetTitle: 'Online Sales Report',
      exampleData: {},
      graphData: []
    }
  },
  created() {
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
      params: {
        a: 'online_sales',
        token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
        params: {
          manufacturer: this.$store.getters.objAuthorize.manufacturer,
          date_from: this.range[0],
          date_to: this.range[1]
        }
      }
    }).then((response) => {
      this.graphData = JSON.parse(response.bodyText);
    });
  },
  mounted() {

  },
  components: {
    DialogFilterConfig
  }
}
</script>

<style>
.widgets tbody {
  display: block;
  max-height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.widgets table.v-table thead th,
.widgets table.v-table tbody td {
  white-space: normal;
}
</style>

